import { createContext, useContext } from 'react';

export interface TreeMenuContextValue {
  /** Called with the `value` of the item the user picks, at any depth. */
  onSelect: (value: string) => void;
}

const TreeMenuContext = createContext<TreeMenuContextValue | null>(null);

export const TreeMenuContextProvider = TreeMenuContext.Provider;

export const useTreeMenuContext = () => {
  const context = useContext(TreeMenuContext);

  if (!context) throw new Error('TreeMenu parts must be rendered inside TreeMenu.Root');

  return context;
};
